import { FormHelperText, InputAdornment, TextField } from '@material-ui/core'
import OpenInBrowserRoundedIcon from '@material-ui/icons/OpenInBrowserRounded'
import { useTranslation } from 'react-i18next'
import { DEFAULT_TRAY_URL, normalizeTrayOpenURL } from 'utils/TrayURL'

import { TrayURLCard, TrayURLPreview } from './style'

export default function TraySettings({ settings, updateSettings }) {
  const { t } = useTranslation()
  const value = settings?.TrayOpenURL ?? DEFAULT_TRAY_URL
  const normalizedURL = normalizeTrayOpenURL(value)
  const isInvalid = normalizedURL === ''

  return (
    <TrayURLCard>
      <div className='tray-url-heading'>
        <span className='tray-url-icon'>
          <OpenInBrowserRoundedIcon />
        </span>
        <div>
          <strong>{t('SettingsDialog.TrayURLTitle')}</strong>
          <small>{t('SettingsDialog.TrayURLSubtitle')}</small>
        </div>
      </div>

      <TextField
        id='TrayOpenURL'
        label={t('SettingsDialog.TrayURLLabel')}
        value={value}
        onChange={event => updateSettings({ TrayOpenURL: event.target.value })}
        onBlur={() => {
          if (normalizedURL) updateSettings({ TrayOpenURL: normalizedURL })
        }}
        placeholder={DEFAULT_TRAY_URL}
        variant='outlined'
        size='small'
        error={isInvalid}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <span className='tray-url-protocol'>URL</span>
            </InputAdornment>
          ),
        }}
      />

      <FormHelperText error={isInvalid}>
        {isInvalid ? t('SettingsDialog.TrayURLInvalid') : t('SettingsDialog.TrayURLHint')}
      </FormHelperText>

      {!isInvalid && (
        <TrayURLPreview>
          <span>{t('SettingsDialog.TrayURLPreview')}</span>
          <code>{normalizedURL}</code>
        </TrayURLPreview>
      )}
    </TrayURLCard>
  )
}
